import { Badge } from "@mantine/core";
import {
  DesignDiscipline,
  DISCIPLINE_DEFINITIONS,
} from "../DesignTab/GlobalDesignBar/designModules";

export const DisciplineBadge: React.FC<{ discipline: DesignDiscipline }> = ({ discipline }) => {
  const def = DISCIPLINE_DEFINITIONS[discipline];

  return (
    <Badge
      variant="filled"
      style={{
        backgroundColor: def.backgroundColor,
        color: def.color,
      }}
    >
      {def.label}
    </Badge>
  );
};
